import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import {
  PRINTER_PROFILE_TAB_ADVANCED,
  PRINTER_PROFILE_TAB_GENERAL,
  PROFILE_TABS,
} from '../../config/constants/printerProfiles';
import { cn, isEmpty } from '../../utils';
import { updateEntity } from './actions';
import Advanced from './Advanced';
import General from './General';
import { makeSelectProperty } from './selector';

const Profile = ({ selectedBranch, selectedProfile, updateField }) => {
  const [selectedTab, setSelectedTab] = useState(PRINTER_PROFILE_TAB_GENERAL);

  useEffect(() => {
    if (isEmpty(selectedProfile)) return;

    setSelectedTab(PRINTER_PROFILE_TAB_GENERAL);

    updateField({
      checkedCategories: [],
      checkedItems: [],
      itemSearchKey: '',
      selectedFilterCategory: null,
      selectedFilterMenu: null,
    });
  }, [selectedProfile]);

  const onTabClicked = tab => {
    if (
      tab.id === PRINTER_PROFILE_TAB_ADVANCED.id &&
      (selectedProfile.is_default || selectedProfile.sticker_printer_enabled)
    ) {
      return;
    }

    setSelectedTab(tab);
  };

  const contentEl = (() => {
    if (isEmpty(selectedProfile)) return null;

    if (selectedTab.id === PRINTER_PROFILE_TAB_ADVANCED.id) {
      return !selectedProfile.is_default ? <Advanced /> : null;
    }

    return <General />;
  })();

  const tabEl = (() => {
    if (!selectedBranch?.printer_routing_enabled) {
      return null;
    }

    const listEl = PROFILE_TABS.map(tab => {
      const isSelected = tab.id === selectedTab.id;

      return (
        <div
          className={cn({
            'flex items-center justify-center px-4 py-2 h-full border-b-2 text-sm cursor-pointer': true,
            'text-primary border-primary font-medium': isSelected,
            'border-grey font-normal': !isSelected,
            'cursor-not-allowed text-grey-darker opacity-25':
              tab.id === PRINTER_PROFILE_TAB_ADVANCED.id &&
              (selectedProfile.is_default ||
                selectedProfile.sticker_printer_enabled),
          })}
          role="presentation"
          onClick={() => onTabClicked(tab)}
        >
          {tab.title}
        </div>
      );
    });

    return <div className="flex">{listEl}</div>;
  })();

  return (
    <div className="flex flex-col gap-y-2 w-2/3">
      <div className="text-lg font-medium flex items-center justify-between w-full rounded-lg border border-grey p-4 bg-white">
        {selectedProfile.profile_name}
        {tabEl}
      </div>
      {contentEl}
    </div>
  );
};

Profile.propTypes = {
  selectedBranch: PropTypes.object,
  selectedProfile: PropTypes.object,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  selectedBranch: makeSelectProperty('selectedBranch'),
  selectedProfile: makeSelectProperty('selectedProfile'),
});

const mapDispatchToProps = dispatch => ({
  updateField: payload => dispatch(updateEntity(payload)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Profile);
